import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import Validator from 'validatorjs';
import { reduce } from 'lodash';
import invariant from 'invariant';

function getErrorMessages(validator) {
  var errors = validator.errors.all();
  return reduce(errors, function (acc, error, field) {
    acc[field] = error[0];
    return acc;
  }, {});
}

function getSingleErrorMessage(name, validator) {
  return validator.errors.first(name);
}

function createValidationRules(definitions) {
  var messages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  invariant(_typeof(messages) === 'object', 'You must pass error messages as an object.');
  var rules = {};
  var attributeNames = {};

  for (var key in definitions) {
    var definition = definitions[key];

    if (_Array$isArray(definition)) {
      rules[key] = definition[0]; // ValidatorJS does not have a way of mapping wildcard field names
      // to attributes so this is a **hacky** workaround to fix that

      if (/(\*)/.test(key)) {
        for (var i = 0; i < 100; i++) {
          var _context;

          attributeNames[_concatInstanceProperty(_context = "".concat(key.split('.*')[0], ".")).call(_context, i)] = definition[1];
        }
      } else {
        attributeNames[key] = definition[1];
      }
    } else {
      rules[key] = definition;
    }
  }

  return function (values) {
    var validator = new Validator(values, rules, messages);
    validator.setAttributeNames(attributeNames);

    if (validator.fails()) {
      return getErrorMessages(validator);
    } else {
      return {};
    }
  };
}

function createSingleValidationRule(name, rules) {
  var messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (value) {
    var validator = new Validator(_defineProperty({}, name, value), _defineProperty({}, name, rules), messages);

    if (validator.fails()) {
      return getSingleErrorMessage(name, validator);
    } else {
      return null;
    }
  };
}

export { createValidationRules, createSingleValidationRule };
export default Validator;